import React from 'react';
import {
  Card,
  CardHeader,
  CardContent,
  TextField,
  Grid,
} from '@mui/material';


export const JobDetailsCard = ({useJobGeneralConfig}) => {
  const statuses = [
    { 
      value: 'enabled',
      label: 'Enabled'
    },
    { 
      value: 'pending',
      label: 'Pending'
    },
    { 
      value: 'error',
      label: 'Error'
    },
    { 
      value: 'disabled',
      label: 'Disabled'
    },
    { 
      value: 'retired',
      label: 'Retired'
    }
  ];

  const [jobName, setJobName] = useJobGeneralConfig(["jobName"]);
  const [jobStatus, setJobStatus] = useJobGeneralConfig(["status"]);
  return <Card>
    <CardHeader title="Job details" subheader="Identifies and controls this feed job" />
    <CardContent>
      <Grid container spacing={2}>
        <Grid item xs={8}>
          <TextField
            fullWidth
            id="job_name"
            label="Job Name"
            variant="standard"
            helperText="Display name used in Charlotte UI and notifications"
            required
            placeholder='e.g. ACME Empower 401k Weekly'
            value={jobName}
            onChange={e => setJobName(e.target.value)}
          />
        </Grid>
        <Grid item xs={4}>
          <TextField
            fullWidth
            label="Status"
            margin="dense"
            name="status"
            onChange={(e) => setJobStatus(e.target.value)}
            required
            value={jobStatus}
            variant="standard"
            select
            // eslint-disable-next-line react/jsx-sort-props
            SelectProps={{ native: true }}
          >
            {statuses.map((option) => (
              <option key={option.value} value={option.value}>
                {option.label}
              </option>
            ))}
          </TextField>
        </Grid>
      </Grid>
    </CardContent>
  </Card>
}
